import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import moment from 'moment'

import Header from '../../shared/components/Header'

import { getAbsenceReport } from '../../actions/absence'

import { translation } from '../../utils/helpers'

// Elements
import TabBar from '../../shared/elements/tabBar'
import TabItem from '../../shared/elements/tabItem'
import Button from '../../shared/elements/button'
import DateTime from '../../shared/elements/datetime'
import Panel from '../../shared/elements/panel'
// import Col from '../../shared/elements/col'
import Row from '../../shared/elements/row'
import TableContainer from '../../shared/elements/tableContainer'
import Inline from '../../shared/elements/inline'
// import Label from '../../shared/elements/label'
// import Grid from '../../shared/elements/grid'

import './index.scss'
import { hasSubscriptionPermission } from '../../utils/auth'
import LabelWrapper from '../../shared/elements/labelWrapper'

class AbsenceReport extends Component {

  constructor (props) {
    super(props)
    this.state = {
      list: [],
      From: '',
      To: ''
    }
    this.renderGroup = this.renderGroup.bind(this)
    this.renderDay = this.renderDay.bind(this)
    this.searchNew = this.searchNew.bind(this)
  }

  componentDidMount () {
    this.getAbsenceReport()
  }

  genPeriod (day) {
    let period1 = moment(day.Date).format('DD.MM')
    let period2 = moment(day.Date).add(4, 'days').format('DD.MM')
    return period1 + ' - ' + period2
  }

  searchNew (e) {
    e.preventDefault()
    this.setState({
      list: []
    })
    this.getAbsenceReport(this.state.From, this.state.To)
  }

  getDateFromInput (input, type) {
    let newDate = moment(input)
    if (typeof input === 'undefined' || !newDate.isValid()) {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth()

      let startDate = moment([year, month])
      let endDate = moment(startDate).endOf('month')

      newDate = (type === 0) ? startDate : endDate
    }
    return newDate.format('YYYY-MM-DD')
  }

  getAbsenceReport (fromDate, toDate) {
    let data = {
      ShopId: 0,
      From: this.getDateFromInput(fromDate, 0),
      To: this.getDateFromInput(toDate, 1)
    }
    this.props.getAbsenceReport(data).then((res) => {
      let grouped = []
      let days = res.data.Days

      // Filter away days -  0 & 6 is weekend
      days = days.filter((day, index) => {
        if (day.WeekDay === 0 || day.WeekDay === 6) return false
        return day
      })

      // Loop through the days and group them together
      let i = 1
      let x = 0
      days.map((day) => {
        if (typeof grouped[x] === 'undefined') {
          grouped[x] = {
            Period: this.genPeriod(day),
            Days: [day]
          }
        } else {
          grouped[x].Days.push(day)
        }

        if (i % 5 === 0) {
          i = 0
          x++
        }
        i++
      })

      this.setState({
        list: grouped
      })
    }, () => {
      console.log('Error getting absence repport')
    })
  }

  getLetterFromType (type) {
    switch (type) {
      case 0:
        return <span className='type blue1'>A</span>
      case 1:
        return <span className='type green1'>D</span>
      case 2:
        return <span className='type green2'>E</span>
      case 3:
        return <span className='type blue2'>B</span>
      case 4:
        return <span className='type blue3'>C</span>
      default:
        return ''
    }
  }

  renderDay (day, key) {
    let momentDate = moment(day.Date)
    let isToday = momentDate.isSame(moment(), 'day')
    let extraClass = ''
    if (isToday) {
      extraClass = 'isToday'
    }
    return (
      <td className={extraClass} key={key}>
        {day.Absence.map((employee, k) => {
          return (
            <Inline spacing={1} block key={k}>{this.getLetterFromType(employee.AwayType)}{employee.EmployeeName}</Inline>
          )
        })}
        <div className='date'><span>{momentDate.format('DD')}</span><span>{momentDate.format('DD-MM-YYYY')}</span></div>
      </td>
    )
  }

  renderGroup (group, key) {
    return (
      <tr key={key}>
        <td>{group.Period}</td>
        {group.Days.map(this.renderDay)}
      </tr>
    )
  }

  onDateChange (name, e) {
    this.setState({
      [name]: e
    })
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null

    const renderInputs = () => {
      return (
        <div className='inputs'>
          <LabelWrapper labelText={translation(188)}>
            <DateTime
              inputProps={{
                name: 'from',
                readOnly: true,
                placeholder: translation('1728')
              }}
              dateFormat='DD-MM-YYYY'
              timeFormat={false}
              closeOnSelect
              value={this.state.From}
              onChange={this.onDateChange.bind(this, 'From')} />
          </LabelWrapper>
          <LabelWrapper labelText={translation(187)}>
            <DateTime
              inputProps={{
                name: 'to',
                readOnly: true,
                placeholder: translation('1728')
              }}
              dateFormat='DD-MM-YYYY'
              timeFormat={false}
              closeOnSelect
              value={this.state.To}
              onChange={this.onDateChange.bind(this, 'To')}
              className='second' />
          </LabelWrapper>
          <Button spacing={0} labelText={translation('380')} onClick={this.searchNew} />
        </div>
      )
    }

    const renderLegend = () => {
      return (
        <div className='legend'>
          <Inline block spacing={0} alignChildren='top'>
            <div>
              <Inline spacing={1} fillChildNum={[2]} block><span className='type blue1'>A</span>{'='}{translation('500')}</Inline>
              <Inline spacing={0} fillChildNum={[2]} block><span className='type blue2'>B</span>{'='}{translation('1436')}</Inline>
            </div>
            <div>
              <Inline spacing={1} fillChildNum={[2]} block><span className='type blue3'>C</span>{'='}{translation('1435')}</Inline>
              <Inline spacing={0} fillChildNum={[2]} block><span className='type green1'>D</span>{'='}{translation('508')}</Inline>
            </div>
            <Inline spacing={0} fillChildNum={[2]} block><span className='type green2'>E</span>{'='}{translation('502')}</Inline>
          </Inline>
        </div>
      )
    }

    const renderTop = () => {
      return (
        <Row>
          <div className='top'>
            <Panel title='' clearfix>
              <div className='topflex'>
                {renderInputs()}
                <div className='filler' />
                {renderLegend()}
              </div>
            </Panel>
          </div>
        </Row>
      )
    }

    return (
      <div className='absence__screen'>
        <Header router={this.props.router} >
          <TabBar>
            <TabItem><Link to={'/punchreport'} >{translation('2159')}</Link></TabItem>
            <TabItem><Link to={'/punchedit'}>{translation('2206')}</Link></TabItem>
            <TabItem><Link to={'/absencereport'} className='active'>{translation('1128')}</Link></TabItem>
          </TabBar>
        </Header>
        <Row>
          {renderTop()}
        </Row>
        <Row>
          <TableContainer>
            <table className='calendar'>
              <tbody>
                <tr className='table__header'>
                  <td>{translation('434')}</td>
                  <td>{translation('169')}</td>
                  <td>{translation('170')}</td>
                  <td>{translation('171')}</td>
                  <td>{translation('172')}</td>
                  <td>{translation('173')}</td>
                </tr>
                {this.state.list.map(this.renderGroup)}
              </tbody>
            </table>
          </TableContainer>
        </Row>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getAbsenceReport
})(AbsenceReport)



// WEBPACK FOOTER //
// ./src/app/pages/AbsenceReport/index.js